import { render, staticRenderFns } from "./Vendascategorias.vue?vue&type=template&id=363a7b08&"
import script from "./Vendascategorias.vue?vue&type=script&lang=js&"
export * from "./Vendascategorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports